var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSuriname(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0047 10.4453H0.995125C0.352063 12.1787 0 14.0534 0 16.0105C0 17.9676 0.352063 19.8424 0.995125 21.5757H31.0048C31.648 19.8424 32 17.9676 32 16.0105C32 14.0534 31.648 12.1787 31.0047 10.4453Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0463 32.0107C21.5264 32.0107 26.3624 29.2549 29.2461 25.0542H2.84662C5.73024 29.2549 10.5661 32.0107 16.0463 32.0107Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0463 0.0107422C21.5264 0.0107422 26.3624 2.76649 29.2461 6.96724H2.84662C5.73024 2.76649 10.5661 0.0107422 16.0463 0.0107422Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.4453L17.3813 14.6966H21.8516L18.2351 17.3243L19.6166 21.5757L16 18.9482L12.3834 21.5757L13.7649 17.3243L10.1484 14.6966H14.6187L16 10.4453Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSuriname);
export default __webpack_public_path__ + "static/media/flag_suriname.b81661e3d3f2cf1cae3781e1ebd217ea.svg";
export { ForwardRef as ReactComponent };